import styled from "styled-components";
import {
  fontSizes, 
} from 'styles/theme';
export const Container = styled.div`
  min-height: calc(100vh - 200px);
`

export const TableSearchUsers = styled.form`
  display: flex;
  width: 50%;
  
  button{
    margin-left: ${fontSizes.xl};
  }
`
